export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=5159e135"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/branches/branch/jackpots/index.vue?vue&type=template&id=5159e135
// module id = W9rC
// module chunks = 0